/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsEmailTokenRequestSchema
 */
export interface NotificationsEmailTokenRequestSchema {
    /**
     * 
     * @type {string}
     * @memberof NotificationsEmailTokenRequestSchema
     */
    token: string;
}

/**
 * Check if a given object implements the NotificationsEmailTokenRequestSchema interface.
 */
export function instanceOfNotificationsEmailTokenRequestSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function NotificationsEmailTokenRequestSchemaFromJSON(json: any): NotificationsEmailTokenRequestSchema {
    return NotificationsEmailTokenRequestSchemaFromJSONTyped(json, false);
}

export function NotificationsEmailTokenRequestSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsEmailTokenRequestSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function NotificationsEmailTokenRequestSchemaToJSON(value?: NotificationsEmailTokenRequestSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

